import { render, staticRenderFns } from "./clear-selected-filters-by-group.vue?vue&type=template&id=28bed113&"
import script from "./clear-selected-filters-by-group.vue?vue&type=script&lang=ts&"
export * from "./clear-selected-filters-by-group.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports